import React from "react";
import Select from "react-select";
import { formatSelectOption, localize } from "helpers/function";
import EmptyTable from "views/components/EmptyTable";

const TableRow = ({ category, data, units, unitTypes, selectedUnitTypes, onChangeUnitTypes, onChangeProcessing, t }) => {
  if (!category.claim_objects) return null;

  return category.claim_objects.map((object, i) => (
    <tr key={i} role="row" className="odd">
      {i === 0 ? (
        <td rowSpan={category.claim_objects.length}>{localize(category.name)}</td>
      ) : (
        <td style={{ display: "none" }} />
      )}
      <td>{localize(object.name)}</td>
      <td>
        {unitTypes ? (
          <Select
            value={selectedUnitTypes[object.id]}
            onChange={(e) => onChangeUnitTypes(e, object.id)}
            options={[
              {
                value: "all",
                label: (
                  <strong>
                    <em>Tout sélectionner</em>
                  </strong>
                ),
              },
              ...formatSelectOption(unitTypes, "name", "fr"),
            ]}
            isMulti
            placeholder={t("Veuillez sélectionner le type d'unité")}
            key={object.id}
          />
        ) : null}
      </td>
      <td>
        {units ? (
          <Select
            value={data[object.id]}
            onChange={(e) => onChangeProcessing(e, object.id)}
            options={[
              {
                value: "all",
                label: (
                  <strong>
                    <em>Tout sélectionner</em>
                  </strong>
                ),
              },
              ...formatSelectOption(units, "name", "fr"),
            ]}
            isMulti
            placeholder={t("Veuillez sélectionner le circuit")}
            key={object.id}
          />
        ) : null}
      </td>
    </tr>
  ));
};

const ProcessingCircuitTable = ({
  claimObject,
  showList,
  data,
  selectedUnitTypes,
  units,
  unitTypes,
  onChangeUnitTypes,
  onChangeProcessing,
  t,
}) => {
  return (
    <table
      className="table table-striped- table-bordered table-hover table-checkable dataTable dtr-inline"
      id="myTable"
      role="grid"
      aria-describedby="kt_table_1_info"
      style={{ width: "952px" }}
    >
      <thead>
        <tr role="row">
          <th
            className="sorting"
            tabIndex="0"
            aria-controls="kt_table_1"
            rowSpan="1"
            colSpan="1"
            style={{ width: "80px" }}
            aria-label="Ship City: activate to sort column ascending"
          >
            {t("Catégorie de plainte")}
          </th>
          <th
            className="sorting"
            tabIndex="0"
            aria-controls="kt_table_1"
            rowSpan="1"
            colSpan="1"
            style={{ width: "100px" }}
            aria-label="Ship City: activate to sort column ascending"
          >
            {t("Objets de plainte")}
          </th>
          <th
            className="sorting"
            tabIndex="0"
            aria-controls="kt_table_1"
            rowSpan="1"
            colSpan="1"
            style={{ width: "170px" }}
            aria-label="Ship City: activate to sort column ascending"
          >
            {t("Types d'unité")}
          </th>
          <th
            className="sorting"
            tabIndex="0"
            aria-controls="kt_table_1"
            rowSpan="1"
            colSpan="1"
            style={{ width: "170px" }}
            aria-label="Ship City: activate to sort column ascending"
          >
            {t("Entités de traitement")}
          </th>
        </tr>
      </thead>
      <tbody>
        {claimObject ? (
          showList.length > 0 ? (
            showList.map((category, index) => (
              <TableRow
                key={index}
                category={category}
                data={data}
                units={units}
                selectedUnitTypes={selectedUnitTypes}
                unitTypes={unitTypes}
                onChangeUnitTypes={onChangeUnitTypes}
                onChangeProcessing={onChangeProcessing}
                t={t}
              />
            ))
          ) : (
            <EmptyTable search={true} />
          )
        ) : (
          <EmptyTable />
        )}
      </tbody>
    </table>
  );
};

export default ProcessingCircuitTable;
